function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f4f4;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3",
  "data-name": "Layer 3"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: -1.5,
  width: 330,
  height: 330,
  rx: 165
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 69.23,
  y: 221.31,
  width: 187.54,
  height: 28.69
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M142.54,207.46h11V191h13.64v16.47h11V190.84c10-.45,17.5-2,22.45-4.54a30.76,30.76,0,0,0,17.43-28c0-10.75-5.46-23.15-20.39-27.86a33.54,33.54,0,0,0,8.86-6.32c4.59-4.25,7-10.47,7-18,0-4-1-17.48-13.41-25.4-6.55-4-15.13-5.13-22-5.43V59.54h-11v15.7H153.51V59.54h-11v15.7H127.78V191h14.76Zm11.62-111.6h14.68c9.91,0,18.11.93,18.11,12.34C187,120,178.24,121,169.31,121H154.16Zm0,45.93h12.19c13.79,0,24.34,1.06,24.34,14.37,0,12.5-8.65,13.43-21.85,13.43H154.16Z"
}));

function SvgMBtc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332 330",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMBtc);
export default __webpack_public_path__ + "static/media/mBTC.e524360e.svg";
export { ForwardRef as ReactComponent };